import { getActionTypeFn } from 'shared/state-utils'

export const FEATURE_NAME = 'Order'
export const getActionType = getActionTypeFn(FEATURE_NAME)
